import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Button } from '@radix-ui/themes';

import TextInput from '../../FormStyles/TextInput.jsx';
import { api } from '../../../lib/api';
import { Header } from './Header.jsx';
import { useSignInContext } from '../formContext';
import { SIGN_IN_STEPS } from '../contants';
import styles from '../sign_in.module.css';

export const EmployeeId = ({ userInfo, setUserInfo }) => {
  const { setStep } = useSignInContext();
  const [error, setError] = useState('');

  const { mutate: createUser } = useMutation(
    async () => {
      await api.post('/api/guest_user_conversions/otp', {
        otp: {
          employee_id: userInfo.employeeId,
          email: userInfo.email,
          phone_number: userInfo.phoneNumber,
        },
      });
    },
    {
      onSuccess: () => setStep('code'),
      onError: () => {
        setError('Invalid employee ID');
      },
    },
  );

  const handleSubmit = e => {
    e.preventDefault();
    createUser();
  };

  return (
    <>
      <Header title={'Enter your Employee ID'} />
      <form className={styles.form} onSubmit={handleSubmit}>
        <TextInput
          label="Employee ID"
          placeholder="Enter employee ID"
          value={userInfo.employeeId || ''}
          error={error}
          autoFocus
          onChange={e =>
            setUserInfo(prev => ({ ...prev, employeeId: e.target.value }))
          }
        />
        <Button
          size="3"
          variant="solid"
          mt="5"
          className={styles.signInButton}
          type="submit"
        >
          Next
        </Button>
        <Button
          size="3"
          variant="outline"
          className={styles.signInButton}
          onClick={() => setStep(SIGN_IN_STEPS.UNKNOWN_EMPLOYEE_ID)}
        >
          What&apos;s my Employee ID?
        </Button>
      </form>
      <Button
        size="3"
        variant="soft"
        mt="auto"
        className={styles.signInButton}
        onClick={() => setStep('start')}
      >
        Back
      </Button>
    </>
  );
};
